document.addEventListener("DOMContentLoaded", function () {
	tippy("[data-tippy-content]", {
		allowHTML: true,
		animation: "shift-away",
		arrow: true,
		delay: 200,
		interactive: false,
		maxWidth: 350,
		placement: "top",
		theme: "light-border",
		trigger: "mouseenter focus",
		zIndex: 9999,
	});
});
